import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { TrainingPage } from './training';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [TrainingPage],
    imports: [PagesModule, ComponentsModule],
    exports: [TrainingPage]
})
export class TrainingPageModule { }
